import React, { useEffect, useMemo, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import styled from 'styled-components';
import { useApi } from '~/contexts';
import { colors } from '~/styles';
import { ChartLabel } from './shared';

const Wrapper = styled.div`
  height: 20rem;
`;

export default function ToolCalls({ start, end }) {
  const api = useApi();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!start || !end) return;
    let cancelled = false;
    const fetchData = async () => {
      setIsLoading(true);
      setData(null);
      try {
        const { data } = await api.admin.aiUsage.getToolCalls({ start, end });
        if (!cancelled) setData(data);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };
    fetchData();
    return () => {
      cancelled = true;
    };
  }, [api, start, end]);

  const chartData = useMemo(() => {
    if (!data || data.length === 0) return null;

    return {
      labels: data.map((d) => d.tool),
      datasets: [
        {
          label: 'Successful',
          data: data.map((d) => d.calls),
          backgroundColor: colors.success,
        },
        {
          label: 'Errors',
          data: data.map((d) => d.errors),
          backgroundColor: colors.danger,
        },
      ],
    };
  }, [data]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      x: { stacked: true, ticks: { precision: 0 } },
      y: { stacked: true },
    },
  };

  if (isLoading || !chartData) return null;

  return (
    <div>
      <ChartLabel>Tool Call Frequency</ChartLabel>
      <Wrapper>
        <Bar data={chartData} options={options} />
      </Wrapper>
    </div>
  );
}
